import { Grid } from '@material-ui/core'
import GrinChip from 'components/common/GrinChip'
import useHITagging from 'hooks/useHITagging'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const HiConditionList = ({ conditions = {}, includeOtherTag }) => {
  const { t } = useTranslation()
  const { getTrackingConditionsTypes } = useHITagging()

  const conditionsTypes = getTrackingConditionsTypes()

  const tagLabels = useMemo(
    () =>
      Object.keys(conditions)
        .filter(conditionType => (includeOtherTag ? true : conditionType !== conditionsTypes.Other))
        .map(condition => {
          const selections = conditions[condition].selections
          const conditionLabel = t(`dialogs.scanSummary.treatmentTracking.conditions.${condition}`)

          if (!selections?.length) {
            return conditionLabel
          }

          return `${conditionLabel} (${selections.join(', ')})`
        }),
    [conditions, includeOtherTag, conditionsTypes.Other, t]
  )

  return tagLabels.length > 0 ? (
    <Grid container spacing={1}>
      {tagLabels.map((text, i) => (
        <Grid item key={`gi-condition-${i}`}>
          <GrinChip text={text} />
        </Grid>
      ))}
    </Grid>
  ) : (
    <></>
  )
}

export default HiConditionList
